import ArticlesApi from '@/api/articles';
import StoreBuilder from '../store-builder';

const builder = new StoreBuilder('articles');
builder.addStatePart('articlesCommandables', null, numTiers => ArticlesApi.getArticlesCommandables(numTiers));

builder.addStatePart('adresseLivraisonValide', null, ({ numArticle, numTiers, numAdresse }) => ArticlesApi.validerAdresseLivraison(numArticle, numTiers, numAdresse).then(response => response.valid), 'NONE', 600);

export default builder.build();
